<h4 mat-dialog-title>
  <span *ngIf="!data;else editHeader">
    Creazione nuova tipologia costruttiva
  </span>
  <ng-template #editHeader>
    Modifica tipologia costruttiva {{data.nome}}
  </ng-template>
</h4>

<form [formGroup]="form" class="mt-4" (keydown.enter)="edit()">
  <mat-form-field>
    <mat-label>Nome</mat-label>
    <input matInput formControlName="nome">
  </mat-form-field>
  <mat-form-field>
    <mat-label>Descrizione</mat-label>
    <input matInput formControlName="descrizione">
  </mat-form-field>
</form>
<button mat-raised-button (click)="edit()" color="primary">Salva</button>